import Config from "../../../config";

export async function uploadCategoryCertificate({ file, id, personId, costCenterId, certificateExpirationDate, originalName, path }) {
  try {
    validateRequiredParams({ file, id, personId, costCenterId, originalName, path });

    const formData = new FormData();
    formData.append("id", id);
    formData.append("file", file);
    formData.append("path", path);
    formData.append("pessoa_id", personId);
    formData.append("nome_original", originalName);
    formData.append("centro_custo_id", costCenterId);
    formData.append("data_expiracao_comprovante", certificateExpirationDate);

    const response = await fetch(
      `${Config.baseURL}api/pt-br/center-cost-person/attach-category-certificate`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error uploading certificate: ${errorText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error in uploadCategoryCertificate:", error);
    throw error;
  }
}


function validateRequiredParams(params) {
  const missing = Object.entries(params)
    .filter(([_, value]) => {
      if (value === undefined || value === null) {
        return true;
      }
      if (typeof value === "string" && value.trim() === "") {
        return true;
      }
      if (value && typeof value === "object" && ("size" in value)) {
        return value.size === 0;
      }  
      return false;
    })
    .map(([key]) => key);

  if (missing.length) {
    throw new Error(`Parâmetros obrigatórios ausentes: ${missing.join(", ")}`);
  }
}